import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createAnItem: {
		id: 'business-summary.common.create-item-link.create-an-item',
		defaultMessage: 'Create an item',
		description: 'Link which navigates the user to another to view to create a new issue.',
	},
});
